import { Button, makeStyles } from "@material-ui/core";
import { useState, useEffect } from "react";
import { useHistory } from "react-router";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import "./Home.css";
import GridTableComponent from "../../components/GridTableComponent/GridTableComponent";
import axios from "axios";

const Home = ({user, setUser}) => {
  const [error, setError] = useState(false);
  const [stats, setStats] = useState(null); // Čuvamo sav napredni info u jednom objektu
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL
  })

  useEffect(() => {
    const fetchConfig = async () => {
      try {
          const { data } = await axiosInstance.get("api/auth/config",{
              headers: {
                  token: "Bearer " + JSON.parse(localStorage.getItem("user")).accessToken
              },
            });
            
          // Zato što smo na backendu stavili res.json({ success: true, data: stats })
          if (data.success && data.data) {
              setStats(data.data);
          } else {
              setStats(data); // Fallback ukoliko je affiliate ulogovan (zavisi kako si njega namestio)
          }
      } catch (e) {
          console.error(e);
          if (e.response && e.response.status === 403) {
              window.localStorage.removeItem('user');
              setUser(null);
              history.push("/login");
          }
      }
    };
    
    fetchConfig();
  }, []);

  return (
    <div>
      <div className="content">
        
        {/* Provera da li su se podaci učitali */}
        {!stats ? (
            <p>Učitavanje statistike...</p>
        ) : (
            <div className="admin-dashboard">
                <h2 style={{marginTop: "20px"}}>Glavna Statistika (Overview)</h2>
                <div className="stats-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "15px", marginBottom: "30px" }}>
                    <div style={{ padding: "15px", background: "#f4f4f4", borderRadius: "8px" }}>
                        <p style={{ margin: 0, color: "#666" }}>Lifetime Revenue</p>
                        <h3 style={{ margin: "5px 0 0 0" }}>${stats.overview?.totalRevenue?.toFixed(2) || 0}</h3>
                    </div>
                    <div style={{ padding: "15px", background: "#f4f4f4", borderRadius: "8px" }}>
                        <p style={{ margin: 0, color: "#666" }}>This Month</p>
                        <h3 style={{ margin: "5px 0 0 0" }}>${stats.overview?.thisMonthRevenue?.toFixed(2) || 0}</h3>
                    </div>
                    <div style={{ padding: "15px", background: "#f4f4f4", borderRadius: "8px" }}>
                        <p style={{ margin: 0, color: "#666" }}>Previous Month</p>
                        <h3 style={{ margin: "5px 0 0 0" }}>${stats.overview?.previousMonthRevenue?.toFixed(2) || 0}</h3>
                    </div>
                    <div style={{ padding: "15px", background: "#f4f4f4", borderRadius: "8px" }}>
                        <p style={{ margin: 0, color: "#666" }}>Conversion Rate</p>
                        <h3 style={{ margin: "5px 0 0 0", color: "green" }}>{stats.overview?.conversionRate || 0}%</h3>
                    </div>
                    <div style={{ padding: "15px", background: "#f4f4f4", borderRadius: "8px" }}>
                        <p style={{ margin: 0, color: "#666" }}>Total Tests (Paid / All)</p>
                        <h3 style={{ margin: "5px 0 0 0" }}>{stats.overview?.countPaid} / {stats.overview?.countAll}</h3>
                    </div>
                </div>

                {/* NAPREDNA STATISTIKA */}
                <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", marginBottom: "40px" }}>
                    
                    {/* Po godinama */}
                    <div style={{ flex: "1 1 300px", background: "#fff", padding: "20px", border: "1px solid #ddd", borderRadius: "8px" }}>
                        <h3>Po godinama (Age Groups)</h3>
                        <table style={{ width: "100%", textAlign: "left" }}>
                            <thead>
                                <tr>
                                    <th>Grupa</th>
                                    <th>Plaćeni</th>
                                    <th>Free</th>
                                    <th>CR %</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stats.ageGroups && Object.entries(stats.ageGroups).map(([age, data]) => (
                                    <tr key={age}>
                                        <td><strong>{age}</strong></td>
                                        <td>{data.paid}</td>
                                        <td>{data.unpaid}</td>
                                        <td style={{ color: "green" }}>{data.conversionRate}%</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Po jezicima */}
                    <div style={{ flex: "1 1 300px", background: "#fff", padding: "20px", border: "1px solid #ddd", borderRadius: "8px" }}>
                        <h3>Po jeziku (Languages)</h3>
                        <table style={{ width: "100%", textAlign: "left" }}>
                            <thead>
                                <tr>
                                    <th>Jezik</th>
                                    <th>Plaćeni</th>
                                    <th>Free</th>
                                    <th>Prihod</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stats.languages && Object.entries(stats.languages)
                                    .sort((a, b) => b[1].revenue - a[1].revenue) // Sortiramo po prihodu
                                    .map(([lang, data]) => (
                                    <tr key={lang}>
                                        <td style={{textTransform: "uppercase"}}><strong>{lang}</strong></td>
                                        <td>{data.paid}</td>
                                        <td>{data.unpaid}</td>
                                        <td>${data.revenue}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Po državama */}
                <div style={{ background: "#fff", padding: "20px", border: "1px solid #ddd", borderRadius: "8px", marginBottom: "40px" }}>
                    <h3>Po državama (Top Countries)</h3>
                    <table style={{ width: "100%", textAlign: "left" }}>
                        <thead>
                            <tr>
                                <th>Država</th>
                                <th>Plaćeni</th>
                                <th>Free</th>
                                <th>CR %</th>
                                <th>Prihod</th>
                            </tr>
                        </thead>
                        <tbody>
                            {stats.countries && Object.entries(stats.countries)
                                .sort((a, b) => b[1].paid - a[1].paid) // Sortiramo opadajuće po broju plaćenih
                                .map(([country, data]) => (
                                <tr key={country}>
                                    <td><strong>{country}</strong></td>
                                    <td>{data.paid}</td>
                                    <td>{data.unpaid}</td>
                                    <td style={{ color: "green" }}>{data.conversionRate}%</td>
                                    <td>${data.revenue}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>
        )}

        <br></br>
        
        {/* Tvoja originalna komponenta */}
        <GridTableComponent
          setUser={setUser}
        />
      </div>
    </div>
  );
};

export default Home;